import { Box, Drawer, styled } from '@mui/material'
import { getPxAsRem } from 'shared/utils'

export const StyledDrawer = styled(Drawer)`
    .MuiDrawer-paper {
        display: flex;
        flex-direction: column;
        padding: ${getPxAsRem(24)};
        width: 515px;
        height: 100%;
    }
`

export const StyledHeader = styled(Box)`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: ${getPxAsRem(16)};
`
